import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, Label } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import Select from 'react-select'

const columns = [
    {
        label: "No. Empleado",
        field: "numero_empleado",
        sort: "asc"
    },
    {
        label: "Nombres",
        field: "nombres",
        sort: "asc"
    },
    {
        label: "Apellidos",
        field: "apellidos",
        sort: "asc"
    },
    {
        label: "Dpi",
        field: "dpi",
        sort: "asc"
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class ColaboradorListado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            modalAbierto2: false,
            mostrarSpinner: true,
            idRegistroEliminar: null,
            pagina: 1,
            totalPaginas: 0,
            listaColaborador: [],
            selectedOption: null,
            registro: undefined,
            id: undefined,
            label: undefined,
            paginacionDatos: {
                paginaActual: null,
                paginaSiguiente: null,
                paginaAnterior: null
            },
            page: {
                Lista: undefined,
                paginaActual: 1,
                totalPaginas: 0,
            }
        }
    }

    componentDidMount() {
        this.cargarListado();
        this.colaboradorListaCompleta();
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: 'Codigo: ' + i.numero_empleado + ' Nombre: ' + i.nombres + ' ' + i.apellidos }));

    colaboradorListaCompleta = () => {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/colaboradorSelect').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ listaColaborador: this.formatoSelect(resultado) })
                }
            });
        }/*else{
            if(this.apiRest.getLS('idEmpresa')){
                this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ listaColaborador: this.formatoSelect(respuesta) })
                    }
                });
            }
        }*/
    }

    editarRegistro = registro => {
        this.props.history.replace({ pathname: '/colaboradorFormulario', registro: registro });
    }

    eliminarRegistro = idRegistro => {
        this.apiRest.delete('/colaborador/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Registro eliminado exitosamente!');
                this.ocultarModalEliminar();
                this.cargarListado();
            }
        });
    }

    paginaSiguiente = () => {
        const {
            pagina,
            totalPaginas
        } = this.state
        let pk = pagina + 1;
        if (pk <= totalPaginas) {
            this.solicitarListaColaboradores(pk);
        }
    }

    paginaAnterior = () => {
        const {
            pagina
        } = this.state
        let id = pagina - 1

        if (id >= 1) {
            this.solicitarListaColaboradores(id);
        }
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        if (this.apiRest.getLS('idEmpresa')) {
            /*this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                }
            });*/
            const{
                page
            } = this.state
            let empresa = this.apiRest.getLS('idEmpresa');
            this.apiRest.put('/colaboradorListaPaginacion/'+empresa.id,page).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false, page: respuesta.data ,tabla: this.agregarAccionesRegistro(respuesta.data.Lista) });
                }
            });
        } else {
            if (this.apiRest.getRol()) {
                let pk = this.state.pagina
                this.solicitarListaColaboradores(pk);
            }
        }
    }

    Pagina = (page) => {
        let empresa = this.apiRest.getLS('idEmpresa');
        this.apiRest.put('/colaboradorListaPaginacion/'+empresa.id,page).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ mostrarSpinner: false, page: respuesta.data ,tabla: this.agregarAccionesRegistro(respuesta.data.Lista) });
            }
        });
    }

    nextPage = () => {
        const{
            page
        } = this.state
        if (page.paginaActual < page.totalPaginas) {
            page.paginaActual = page.paginaActual + 1;
            this.Pagina(page);
        }else{
            toastr.warning('No hay más registros')
        }
    }

    previousPage = () => {
        const{
            page
        } = this.state
        if (page.paginaActual > 1) {
            page.paginaActual = page.paginaActual - 1;
            this.Pagina(page);
        }else{
            //toastr.warning('No hay más registros')
        }
    }

    solicitarListaColaboradores = (pk) => {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/colaboradorPagination/' + pk).then(respuesta => {
                if (respuesta.exitoso) {

                    this.setState({ totalPaginas: respuesta.data.totalPaginas });
                    this.setState({ pagina: respuesta.data.paginaActual });
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data.colaboradorListado) });
                }
            });
        }
    }

    botonesListado = registro => [
        this.apiRest.tienePermiso('item_colaborador_editar') ?
            <MDBBtn className="waves-effect" size="sm" color="primary" title="Editar" onClick={() => this.editarRegistro(registro)}>
                <MDBIcon icon="far fa-edit" />
            </MDBBtn>
            : ''
        , ' ',
        this.apiRest.tienePermiso('item_colaborador_eliminar') ?
            <MDBBtn className="waves-effect" size="sm" color="danger" title="Eliminar" onClick={() => this.mostrarModalEliminar(registro.id)}>
                <MDBIcon icon="fas fa-times" />
            </MDBBtn>
            : ''
    ];

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    mostrarModalEliminar2 = idRegistro => {
        this.setState({
            modalAbierto2: false,
            modalAbierto: true,
            idRegistroEliminar: idRegistro,
            selectedOption: null
        });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: null });
    }

    cancelarModal = () => {
        this.setState({ selectedOption: null, modalAbierto2: false });
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
        if (_valid(selectedOption)) {
            this.consultarColaboradorid(selectedOption.value);
        }
    }

    consultarColaboradorid = (id) => {
        this.apiRest.get('/colaborador/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ registro: resultado.data });
                let registro = resultado.data;
                this.setState({ label: "Nombre Colaborador: " + registro.nombres + "\n" + registro.apellidos });
                this.setState({ id: registro.id });
                //this.props.history.replace({ pathname: '/colaboradorFormulario', registro: this.state.registro });
            }
        });
        this.setState({ modalAbierto2: true });
    }

    render() {
        const {
            pagina,
            totalPaginas,
            listaColaborador,
            selectedOption
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Listado" breadcrumbItem="Colaborador" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    {
                                        _valid(this.apiRest.getEmpresaNombre()) ?
                                            <Label htmlFor="#" className="form-label">
                                                {'Empresa: ' + this.apiRest.getEmpresaNombre()}
                                            </Label> : ''
                                    }
                                    <CardBody>
                                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.cargarListado()}>
                                            <MDBIcon icon="fa fa-info-circle" />{' '}
                                            Actualizar Listado
                                        </MDBBtn>
                                        {' '}
                                        {
                                            this.apiRest.tienePermiso('item_colaborador_agregar') ?
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.props.history.replace('/colaboradorFormulario')}>
                                                    <MDBIcon icon="fas fa-user-plus" />{' '}
                                                    Nuevo
                                                </MDBBtn>
                                                : ''
                                        }
                                        <p />
                                        {
                                            <Col className="col-8">
                                                <Label htmlFor="#" className="form-label">
                                                    Colaborador:
                                                </Label>
                                                <Select
                                                    name="colaborador"
                                                    options={listaColaborador}
                                                    value={selectedOption}
                                                    onChange={this.handleChange}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Buscar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "Cargando..."}
                                                />
                                            </Col>
                                        }
                                        <p />

                                        {this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            {
                                                this.apiRest.getRol() ?
                                                    <Row>
                                                        <MDBDataTable entries={50} searching={false} paging={false} noRecordsFoundLabel="No hay datos." data={this.state.tabla} />
                                                        {' '}
                                                        <Col>
                                                            <Label htmlFor="#" className="form-label">
                                                                {'Numeró de Paginá: ' + pagina}
                                                            </Label>
                                                            {' '}
                                                            <MDBBtn className="waves-effect" color="primary" onClick={() => this.paginaAnterior()}>
                                                                <MDBIcon icon="fas fa-angle-double-left" /> {' '}
                                                                Paginá Anterior
                                                            </MDBBtn>
                                                            {' '}
                                                            <Label htmlFor="#" className="form-label">
                                                                {'Total de Paginás: ' + totalPaginas}
                                                            </Label>
                                                            {' '}
                                                            <MDBBtn className="waves-effect" color="primary" onClick={() => this.paginaSiguiente()}>
                                                                Paginá Siguiente
                                                                {' '}<MDBIcon icon="fas fa-angle-double-right" />
                                                            </MDBBtn>
                                                            <p />
                                                        </Col>
                                                    </Row>
                                                    :
                                                    <Row>
                                                        <MDBDataTable entries={100} hover  searching={false} paging={false} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                    <Col>
                                                    <Label htmlFor="#" className="form-label">
                                                        {'Numeró de Paginá: ' + this.state.page.paginaActual}
                                                    </Label>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="primary" onClick={() => this.previousPage()}>
                                                        <MDBIcon icon="fas fa-angle-double-left" /> {' '}
                                                        Paginá Anterior
                                                    </MDBBtn>
                                                    {' '}
                                                    <Label htmlFor="#" className="form-label">
                                                        {'Total de Paginás: ' + this.state.page.totalPaginas}
                                                    </Label>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="primary" onClick={() => this.nextPage()}>
                                                        Paginá Siguiente
                                                        {' '}<MDBIcon icon="fas fa-angle-double-right" />
                                                    </MDBBtn>
                                                    <p />
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Registro
                    </ModalHeader>
                    <ModalBody>
                        Esta seguro?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.eliminarRegistro(this.state.idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                {/* MODAL BUSCADOR SELECT*/}
                <Modal isOpen={this.state.modalAbierto2} size="mm">
                    <ModalHeader>
                        {this.state.label}
                    </ModalHeader>
                    <ModalBody>
                        Opciones disponibles:
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" size="MD" color="success" title="Editar" onClick={() => this.editarRegistro(this.state.registro)}>
                            <MDBIcon icon="fas fa-edit" />
                        </MDBBtn>
                        <MDBBtn className="waves-effect" size="MD" color="warning" title="Cancelar" onClick={() => this.cancelarModal()}>
                            <MDBIcon icon="fas fa-undo-alt" />
                        </MDBBtn>
                        <MDBBtn className="waves-effect" size="MD" color="danger" title="Eliminar" onClick={() => this.mostrarModalEliminar2(this.state.id)}>
                            <MDBIcon icon="fas fa-eraser" />
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}